import React, { useState, useEffect } from 'preact/compat';
import { ComponentChildren } from 'preact';
import clsx from 'clsx';
import { isValidMimeType } from '../../../lib/file';

export default function DropTarget({ children, allowedTypes = [], disabled, onDrop }: DropZoneProps) {
    const [valid, setValid] = useState<boolean | null>(null);
    const className = clsx('drop-target', {
        'drop-target--inactive': valid === null,
        'drop-target--valid': valid === true,
        'drop-target--invalid': valid === false,
        'drop-target--disabled': disabled,
    });

    function handleDragOver(event: DragEvent) {
        const valid = isValid(event);
        setValid(valid);

        if (event.dataTransfer !== null) {
            event.dataTransfer.dropEffect = valid ? 'copy' : 'none';
        }

        event.preventDefault();
    }

    function handleDragLeave() {
        setValid(null);
    }

    function handleDrop(event: DragEvent) {
        event.preventDefault();

        if (event.dataTransfer !== null && isValid(event)) {
            onDrop(event.dataTransfer.files);
        }

        setValid(null);
    }

    function isValid(event: DragEvent) {
        if (disabled || event.dataTransfer === null) {
            return false;
        }

        return Array.from(event.dataTransfer.items).every(({ kind, type }) => {
            return kind === 'file' && isValidMimeType(type, allowedTypes);
        });
    }

    return (
        <div
            onDragOverCapture={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            className={className}>
            {children}
        </div>
    );
}

type DropZoneProps = {
    children: ComponentChildren,
    allowedTypes?: string[],
    disabled?: boolean,
    onDrop: (files: FileList) => void,
};
